import { CommandBase } from "~app/common/services/cqs/commandManager";

export class CreateAnvandareVikarieCommand extends CommandBase {
    anvandareId: number;
    vikarieId: number;
    franDatum: string;
    tillDatum: string;

    constructor(init: (instance: CreateAnvandareVikarieCommand) => void) {
        super("CreateAnvandareVikarieCommand");
        init(this);
    }
}
